/* Ape Coffee — ape-order.js. The theme's first Ape JavaScript asset.
 *
 * One custom element, <order-ahead-link>, wrapped around a real anchor. It
 * upgrades a click on a global "Order Ahead" control into the location picker
 * (snippets/order-ahead-picker.liquid) instead of a page load.
 *
 * Nothing here is required for the link to work. Every trigger the theme
 * renders is an <a href> to the locations page, so with this file missing,
 * blocked, or broken the customer still reaches each shop's ordering link one
 * page away (ia-navigation.md §4.2). Revenue routing does not depend on
 * JavaScript, and it must stay that way.
 *
 * The dialog is looked up at click time, not on connect. Dawn's ModalDialog
 * moves itself to <body> in connectedCallback, and the order in which the two
 * elements upgrade is not guaranteed, so a reference taken early can point at
 * an element that has since moved or has not yet been upgraded.
 */

class OrderAheadLink extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.link = this.querySelector('a[href]');
    if (this.link) this.link.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    // Anything that is not a plain left click is the customer asking the
    // browser for a page — a new tab, a new window, a saved link. Leave it.
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const modal = document.querySelector(this.getAttribute('data-modal'));
    if (!modal || typeof modal.show !== 'function') return;

    event.preventDefault();

    const drawer = this.closest('header-drawer, menu-drawer');
    const summary = drawer && drawer.querySelector('summary');
    if (drawer && summary && typeof drawer.closeMenuDrawer === 'function') {
      // Close the drawer first, or the dialog opens behind it and the body
      // keeps the drawer's scroll lock. Dawn resets aria-expanded only when the
      // drawer is closed from the keyboard, so set it here as well. Focus is
      // handed to the hamburger rather than to a link inside a closed drawer.
      drawer.closeMenuDrawer(event, summary);
      summary.setAttribute('aria-expanded', 'false');
      modal.show(summary);
      return;
    }

    modal.show(this.link);
  }
}

if (!customElements.get('order-ahead-link')) customElements.define('order-ahead-link', OrderAheadLink);
